import type { ActiveSwitchTest, VpnKey } from '@/types'

function groupKeyOf(key: VpnKey): string {
  return key.group_key || `id:${key.id}`
}

export function groupMatchesSwitchTest(keys: VpnKey[], test: ActiveSwitchTest): boolean {
  if (keys.some((k) => k.id === test.switchKeyId)) {
    return true
  }
  if (test.switchGroupKey && keys.some((k) => groupKeyOf(k) === test.switchGroupKey)) {
    return true
  }
  return false
}

export function findTestForGroup(keys: VpnKey[], tests: ActiveSwitchTest[]): ActiveSwitchTest | null {
  for (const test of tests) {
    if (groupMatchesSwitchTest(keys, test)) return test
  }
  return null
}

export function splitKeysForSwitch(
  keys: VpnKey[],
  test: ActiveSwitchTest,
): { oldKeys: VpnKey[]; newKeys: VpnKey[] } {
  const scoped = test.switchGroupKey
    ? keys.filter((k) => groupKeyOf(k) === test.switchGroupKey)
    : keys.filter((k) => k.id === test.switchKeyId)

  const oldKeys: VpnKey[] = []
  const newKeys: VpnKey[] = []
  for (const key of scoped) {
    const onNewServer =
      (test.newServerId > 0 && key.server_id === test.newServerId)
      || (test.newServerName !== '' && key.server_name === test.newServerName)
    if (onNewServer) {
      newKeys.push(key)
    } else {
      oldKeys.push(key)
    }
  }
  return { oldKeys, newKeys }
}
